"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _FlexRow = require("../../layout/flex/FlexRow");
var _Icon = require("../../media/icon/Icon");
var _DropdownList = _interopRequireDefault(require("../../controls/dropdown/DropdownList"));
var _InnerButton = require("../../controls/buttons/InnerButton");
var _jsxRuntime = require("react/jsx-runtime");
var DraggableContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "DraggableContainer__DraggableContainerWrapper",
  componentId: "sc-tpda6u-0"
})(["background-color:", ";border-radius:4px;padding:6px 12px;cursor:grab;height:", ";"], _tokens.default.sky.ref.color.coolneutral['900'], _tokens.default.sky.sys.spacing[1400]);
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "DraggableContainer__IconWrapper",
  componentId: "sc-tpda6u-1"
})(["svg{path{fill:", ";}}&:hover{background-color:", ";svg{path{fill:", ";}}border-radius:", ";}&:focus{background-color:", ";color:", ";border:", " solid ", ";border-radius:", ";svg{path{fill:", ";}}}"], _tokens.default.sky.sys.color.iconfill.ondark, _tokens.default.sky.sys.color.background.primary[1], _tokens.default.sky.sys.color.iconfill.onlight, _tokens.default.sky.sys.size.borderradius[2], _tokens.default.sky.sys.color.background.primary[1], _tokens.default.sky.sys.color.iconfill.onlight, _tokens.default.sky.sys.size.borderwidth.thick, _tokens.default.sky.sys.color.border.focusring, _tokens.default.sky.sys.size.borderradius[2], _tokens.default.sky.sys.color.iconfill.onlight);
var StyledIcon = function StyledIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(IconWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread({}, props))
  });
};
var ContextMenu = function ContextMenu(_ref) {
  var contextMenuOptions = _ref.contextMenuOptions;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DropdownList.default, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Trigger, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.NonVisualButton, {
        "data-cy": 'open-context-menu',
        "aria-label": 'Open context menu',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
          icon: 'more',
          size: 'l'
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Content, {
      children: contextMenuOptions.map(function (option) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Item, {
          onClick: option.onClick,
          disabled: option.disabled,
          "data-cy": "context-list-option-" + option.name.toLowerCase().replace(/ /g, '-'),
          children: option.name
        });
      })
    })]
  });
};
var DraggableContainer = function DraggableContainer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DraggableContainerWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
      gap: 'm',
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
        icon: 'drag',
        size: 'l'
      }), children]
    })
  });
};
DraggableContainer.ContextMenu = ContextMenu;
var _default = exports.default = DraggableContainer;